import { z } from 'zod';

/**
 * Identificativi dei 5 allineamenti di DWR.
 * Riferimento: manuale draft, sezione "Allineamento".
 */
export const AlignmentIdSchema = z.enum(['buono', 'legale', 'neutrale', 'caotico', 'malvagio']);
export type AlignmentId = z.infer<typeof AlignmentIdSchema>;

export const ALIGNMENT_IDS = AlignmentIdSchema.options;

/**
 * Scelta di allineamento del PG.
 * Il `precept` è l'azione-trigger che fa segnare PE quando viene compiuta;
 * può essere uno dei preset del manuale (per allineamento + classe) oppure
 * un testo custom concordato col tavolo. Per semplicità lo storiamo come
 * stringa: i preset sono mostrati dalla UI come suggerimenti.
 */
export const AlignmentChoiceSchema = z.object({
  id: AlignmentIdSchema,
  precept: z.string().min(1).max(300),
});
export type AlignmentChoice = z.infer<typeof AlignmentChoiceSchema>;
